import React from 'react';
import { FiX, FiTarget, FiUser, FiChevronRight } from 'react-icons/fi';
import './HandicapEditChoiceModal.css';

/**
 * Prompts the user to choose which handicap to edit before the keypad opens:
 *  - Playing handicap (this round only; integer)
 *  - Handicap index (the player's stored index; decimal, recomputes playing hcp)
 */
const HandicapEditChoiceModal = ({
  isOpen,
  playerName,
  currentPlayingHandicap,
  currentIndex,
  onChoose,   // (mode: 'playing' | 'index') => void
  onClose,
  // Optional copy overrides — used by the team-round flow, where editing one
  // member here recomputes the WHOLE team's handicap (and rescoring every
  // entered hole), not just this player's, so the individual page's default
  // wording would understate what's about to happen.
  playingNote = 'This round only',
  indexNote = "Player's index",
  footnote = "Changing the index recalculates this round's playing handicap.",
}) => {
  if (!isOpen) return null;

  const fmt = (v, decimals) =>
    v === null || v === undefined || v === '' ? '—'
      : (decimals ? Number(v).toFixed(1) : String(v));

  return (
    <div className="hec-overlay" onClick={onClose}>
      <div className="hec-modal" onClick={e => e.stopPropagation()}>
        <button className="hec-close" onClick={onClose}><FiX size={16} /></button>

        <div className="hec-header">
          <span className="hec-eyebrow">Edit Handicap</span>
          {playerName && <span className="hec-player">{playerName}</span>}
          <div className="hec-divider" />
          <p className="hec-prompt">What would you like to change?</p>
        </div>

        <button className="hec-option" onClick={() => onChoose('playing')}>
          <div className="hec-option-icon hec-option-icon--playing"><FiTarget size={20} /></div>
          <div className="hec-option-text">
            <span className="hec-option-title">Playing Handicap</span>
            <span className="hec-option-sub">{playingNote} · currently {fmt(currentPlayingHandicap, false)}</span>
          </div>
          <FiChevronRight size={18} className="hec-option-arrow" />
        </button>

        <button className="hec-option" onClick={() => onChoose('index')}>
          <div className="hec-option-icon hec-option-icon--index"><FiUser size={20} /></div>
          <div className="hec-option-text">
            <span className="hec-option-title">Handicap Index</span>
            <span className="hec-option-sub">{indexNote} · currently {fmt(currentIndex, true)}</span>
          </div>
          <FiChevronRight size={18} className="hec-option-arrow" />
        </button>

        <p className="hec-footnote">{footnote}</p>
      </div>
    </div>
  );
};

export default HandicapEditChoiceModal;
